"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var setItemsFlagState_1 = require("./setItemsFlagState");
var setConversationsFlagState_1 = require("./setConversationsFlagState");
var getInstrumentationContextsFromTableView_1 = require("owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView");
function setMailListRowsFlagState(rowKeys, tableViewId, flagStatusToApply) {
    var tableView = Store_1.default.tableViews.get(tableViewId);
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(rowKeys, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            setConversationsFlagState_1.default(rowKeys, instrumentationContexts, tableViewId, flagStatusToApply);
            break;
        case 1 /* Message */:
            setItemsFlagState_1.setItemsFlagStateFromTable(rowKeys, instrumentationContexts, tableViewId, flagStatusToApply);
            break;
    }
}
exports.default = setMailListRowsFlagState;
//# sourceMappingURL=setMailListRowsFlagState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/setMailListRowsFlagState.js
// module id = 3816
// module chunks = 62